import React from 'react'
import skAnna from "../../../images/surge/sk-anna.webp"
import macApp from "../../../images/surge/mac-app-studio-icon.svg"
import pepul from "../../../images/surge/pepul-icon.svg"
import workfast from "../../../images/surge/workfast-icon.svg"

export default function Philosophy() {
    return (
        <div className='mb-[20px] sm:mb-[50px] xl:mb-[70px] p-[20px] relative z-0 w-full overflow-hidden text-center bg-[#FEFCE8]'>
            <img src={skAnna} alt='skAnna' loading='lazy' className='size-[200px] md:size-[300px] lg:size-[500px] rounded-[24px] md:rounded-[58px] mx-auto object-cover' />
            <div className='mt-[10px]'>
                <h4 className='text-[#101828] text-[22px] md:text-[34px] font-bold'>Suresh Kumar (SK)</h4>
                <p className='mt-[4px] text-[#4A5565] text-[16px] md:text-[22px] font-normal'>Serial Entrepreneur & Mentor</p>
                <div className='flex gap-[20px] md:gap-[57px] items-center justify-center text-[14px] md:text-[18px] text-[#000] font-semibold mt-[10px] md:mt-[20px] flex-wrap'>
                    <div className='flex gap-[7px] items-center justify-center'>
                        <img src={macApp} alt='macApp' loading='lazy' />
                        <p>MacAppStudio</p>
                    </div>
                    <div className='flex gap-[7px] items-center justify-center'>
                        <img src={pepul} alt='pepul' className='w-[30px] md:w-auto' loading='lazy' />
                        <p>Pepul Tech</p>
                    </div>
                    <div className='flex gap-[7px] items-center justify-center'>
                        <img src={workfast} alt='workfast' className='w-[30px] md:w-auto' loading='lazy' />
                        <p>Workfast.ai</p>
                    </div>
                </div>
            </div>
            <div className='mt-[20px] md:mt-[46px]'>
                <h5 className='text-[#101828] font-semibold text-[24px] md:text-[54px]'>THE SK PHILOSOPHY</h5>
                <p className='mt-[12px] md:mt-[25px] text-[#000000CC] font-medium text-[14px] md:text-[28px]'>We don’t give you a job. <br className='hidden md:block'/> We prepare you so well you earn it yourself. <br className='hidden md:block'/> We don’t make placement guarantees. We don’t sell dreams. We don’t give fish.</p>
            </div>
            <div className='mt-[20px] md:mt-[32px] lg:mt-[42px] bg-[#DEC00914] w-full md:w-9/12 mx-auto rounded-[12px] md:rounded-[20px] p-[15px] md:p-[24px] text-[#AE9600] text-center font-medium text-[20px] md:text-[24px]'>
                <p>We teach you how to fish — So you can feed yourself for life.</p>
                <p className='mt-[10px]'>— SK — </p>
            </div>
        </div>
    )
}
